import { render, staticRenderFns } from "./BrandAuthApply.vue?vue&type=template&id=8e2fcffc"
import script from "./BrandAuthApply.vue?vue&type=script&lang=ts"
export * from "./BrandAuthApply.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDataTable,VImg})
